<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VJLhEQ/images/cover.jpg?1700571411174" alt="This image is the cover for the book Mines and Miners of Cornwall and Devon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mines and Miners of Cornwall and Devon
      </h1>
      <p class="bookDescription body article font2">
        <b>The eminent historian and author of <i>The Rise of King Cotton</i> uncovers the centuries-old story of tin mining in Southern England.</b><br/><br/>Tin mining has existed in Cornwall and parts of Devon since before the Romans arrived in Britain. In this book, historian Anthony Burton explores the region’s tin mining industry from its earliest period through to the present day.<br/><br/>A specialist in the history of technology, Burton examines the evolution of extraction methods from primitive pick and shovel operations to the later use of explosives, the rise of steam power, and beyond. Burton also looks at the changing politics and economics of the tin mining industry over the centuries.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Burton
      </h2>
      
      <p class="authorDescription body article">Anthony Burton is a freelance author and broadcaster, who has specialized in industrial and transport history. He has been involved in around a hundred TV documentaries on these subjects, appearing on all the major networks. He has  written biographies of some of the leading characters of the early industrial age: Thomas Telford, Richard Trevithick, Joseph Locke and Matthew Boulton, the latter with Jennifer Tann</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4d1223c